import { render } from "./vbossintcus.vue?vue&type=template&id=cca03c0a&scoped=true"
import script from "./vbossintcus.vue?vue&type=script&lang=js"
export * from "./vbossintcus.vue?vue&type=script&lang=js"

import "./vbossintcus.vue?vue&type=style&index=0&id=cca03c0a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca03c0a"]])

export default __exports__